export default __webpack_public_path__ + "static/Ksablack-1-2c7dd0396fc611b5fc015a2891259faa.webp";